import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { inject, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DateAdapter, MatNativeDateModule, MAT_DATE_FORMATS, MAT_NATIVE_DATE_FORMATS } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogTitle } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { Router, RouterModule } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import moment from 'moment';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import { RolesModel } from '../../../Data/Models/Users/roles-model';
import { TextMaskDateDirective } from '../../../Directives/text-mask-date-directive.directive';
import { ValidateOnTouchDirective } from '../../../Directives/validate-on-touch.directive';

import { MaterialModule } from '../../../material.module';
import { UsermanagementService } from '../../../services/apps/usermanagement/usermanagement.service';
import { MessageServiceService } from '../../../Shared/common/message-service.service';
import { CustomDateAdapter } from '../../../Shared/common/ng-date-parse-adapter';
import { AccountDetailsModal, CharityDetailsModal } from '../charities/addcharities/CharityDetailsModal';

import { CharitiesService } from '../charities/services/charities.service';
import { CharityDataShareServiceService } from '../charities/services/charity-data-share-service.service';
import { FinalAccountsapiService } from '../final-accounts/final-accountsapi.service';
import { BasicInformationDataShareService } from './basic-information-data-share.service';


@Component({
  selector: 'app-basic-information',
  imports: [
    MaterialModule,
    TablerIconsModule, MatProgressSpinnerModule,
    MatNativeDateModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogModule,
    NgScrollbarModule, NgxSpinnerModule, RouterModule, CommonModule,
    FormsModule, ReactiveFormsModule, MatRadioModule, MatDatepickerModule, TextMaskDateDirective, MatTableModule, AsyncPipe, ValidateOnTouchDirective
  ],
  providers: [{ provide: DateAdapter, useClass: CustomDateAdapter },
  { provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS }, DatePipe],
  templateUrl: './basic-information.component.html',
  styleUrl: './basic-information.component.scss'
})
export class BasicInformationComponent implements OnInit {
  selectmethod: string = ''
  selectedvalue: string = "yes";
  checktracking: boolean = true;
  CurrentCharityDetails: CharityDetailsModal;
  Basicinfodata: any = [];
  isFirst_AP: string = "yes";
  apFinalised: boolean = false

  // CharityFinancialSubForm: FormGroup


  AccountPeriodGrid: any = [];
  private hasExecutedValidation: boolean = false;
  private _formBuilder = inject(FormBuilder);
  diffDays: number;
  createdDate: string;
  modifiedDate: string;
  totalDaysCount: number;
  totalMonthsCount: number;
  dateofRemoval: any;
  dateofRegistration: any;
  submissionDeadline: any;
  auditExemptionStatement: boolean = false;
  auditCheck: boolean = false;
  SubmissionStatus: any;
  substatus: any = '';
  ShowSpinner: any = false;

  constructor(public dialog: MatDialog, public datashare: BasicInformationDataShareService, private _UsermanagementService: UsermanagementService,
    private dataShareService: CharityDataShareServiceService, public Charities_Service: CharitiesService,
    private msgService: MessageServiceService, private spinner: NgxSpinnerService, private router: Router, private apiservice: FinalAccountsapiService, private sharedService: CharityDataShareServiceService) {
    /* alert('hitted comnstrictor')*/
    this.GetUserAccess()
    this.Getbasicinformation()
    this.Getcharitydetails()
    this.GetAccountingPeriods()
    this.datashare.CreateFinancialSubForm()
  }
  ngOnInit() {
    this.dataShareService.CurrentAP_ID$.subscribe((data: any) => {
      this.GetUserAccess()
    })
    //this.dataShareService.finalStatus$.subscribe((value: any) => {
    //  this.apFinalised = value != '' && value == 'Completed'
    //})
    this.SubmissionStatus = localStorage.getItem('SubmissionStatus');
  }

  UserRoleAccess: RolesModel;
  GetUserAccess() {
    this.ShowSpinner = true;
    this._UsermanagementService.GetUserRoleAccess(localStorage['userID']).subscribe(data => {
      if (data.entity.length) {
        this.ShowSpinner = false;
        this.UserRoleAccess = data.entity[0]
        var submitedDate = this.UserRoleAccess.currentAPSubmitDate
      }
      this.ShowSpinner = true;
      this.dataShareService.finalStatus$.subscribe((value: any) => {
        this.apFinalised = value != '' && value == 'Completed'
        this.ShowSpinner = false;
      })
    });
  }

  accMtdChange() {
    debugger
    if (this.datashare.CharityFinancialSubForm.controls['accounting_Method'].value != 'Cash (Receipts & Payments)') {
      const accountingTemplateControl = this.datashare.CharityFinancialSubForm.controls['accounting_Template'];
      // Add validators
      this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].enable();
      accountingTemplateControl.setValidators([Validators.required]);
      // Update the control's status
      accountingTemplateControl.updateValueAndValidity()
      this.datashare.CharityFinancialSubForm.controls['accounting_Template'].reset();
    }
    else {
      const accountingTemplateControl = this.datashare.CharityFinancialSubForm.controls['accounting_Template'];
      // remove validators
      this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].setValue(true);
      this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].disable();
      accountingTemplateControl.clearValidators();
      accountingTemplateControl.updateValueAndValidity()
    }
  }
  getFinancialYear(date: Date, financialYearStartMonth: number): { startYear: number; endYear: number } {
    const year = date.getFullYear();
    const month = date.getMonth();
    let startYear: number;
    let endYear: number;
    if (month < financialYearStartMonth) {
      startYear = year - 1;
      endYear = year;
    } else {
      startYear = year;
      endYear = year + 1;
    }
    return { startYear, endYear };
  }

  CurrentDate_Validate(Event?: any, controllerName?: any) {
    debugger
    if (controllerName == 'current_AP_Start_Date') {
      const isValidDate = moment(this.datashare.CharityFinancialSubForm.controls['current_AP_Start_Date'].value, 'DD/MM/YYYY', true).isValid();
      if (this.isFirst_AP == "no" && (this.datashare.CharityFinancialSubForm.controls['last_AP_Start_Date'].value == null || this.datashare.CharityFinancialSubForm.controls['last_AP_End_Date'].value == null)) {
        if (this.datashare.CharityFinancialSubForm.controls['last_AP_Start_Date'].value == null) {
          this.datashare.CharityFinancialSubForm.controls['last_AP_Start_Date'].setErrors({ required: true });
          this.datashare.CharityFinancialSubForm.get('last_AP_Start_Date')?.markAsTouched();
        }
        if (this.datashare.CharityFinancialSubForm.controls['last_AP_End_Date'].value == null) {
          this.datashare.CharityFinancialSubForm.controls['last_AP_End_Date'].setErrors({ requireddate: true });
          this.datashare.CharityFinancialSubForm.get('last_AP_End_Date')?.markAsTouched();
        }
      }
      else {
        this.datashare.CharityFinancialSubForm.controls['last_AP_Start_Date'].setErrors(null);
        this.datashare.CharityFinancialSubForm.controls['last_AP_End_Date'].setErrors(null);
      }
      if (!isValidDate) {
        this.datashare.CharityFinancialSubForm.controls['current_AP_Start_Date'].setErrors({ Invalid: true });

      }
      else {
        this.datashare.CharityFinancialSubForm.controls['current_AP_Start_Date'].setErrors(null);
        this.onStartDateChange(Event)
      }
    }
    else if (controllerName == 'current_AP_End_Date') {
      const isValidDate = moment(this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].value, 'DD/MM/YYYY', true).isValid();


      if (!isValidDate) {
        this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].setErrors({ Invalid: true });

      }
      else {
        this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].setErrors(null);
        //this.onStartDateChange(Event)
      }
      if (this.AccountPeriodGrid?.length > 1) {
        var currentperiod = localStorage.getItem('currentPeriod')
        var index = this.AccountPeriodGrid.findIndex((item: any) => item.financialPeriodsID.toString() === currentperiod);
        if (index > 0) {
          let nextstartdate = new Date(this.AccountPeriodGrid[index - 1]?.current_AP_Start_Date)
          var currentenddate = new Date(this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].getRawValue())
          if (currentenddate > nextstartdate) {
            this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].setErrors({ merge: true });

          }
        }
      }
    }

  }
  ChangeFundType() {
    debugger
    var _type = this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].getRawValue() == true ? 'true' : 'false'
    if (_type != localStorage.getItem('fund_Tracking')) {
      Swal.fire({
        html: '<h2 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Changing the Fund Type will erase the data you have already entered for this period. </h2> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">Are you sure you want to continue?',
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          return
        }
        else {
          this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].setValue(!this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].getRawValue())
          return

        }
      })
    }
  }

  DbDateConverter(ControllerDate: any) {
    if (ControllerDate) {
      // Create a moment object in local time
      const momentDate = moment(ControllerDate);

      // Set the time to midnight (start of the day)
      const localMidnight = momentDate.startOf('day');

      // Format the date to the desired format
      const formattedDate = localMidnight.format('YYYY-MM-DDTHH:mm:ss.SS[Z]');

      console.log(formattedDate);
      return formattedDate;
    } else {
      return null;
    }
  }
  onStartDateChange(event: any) {
    debugger;
    if (event.target.value == null) {
      this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].setValue(null);
      this.datashare.CharityFinancialSubForm.controls['current_AP_Start_Date'].setValue(null);
      this.datashare.CharityFinancialSubForm.controls['financial_Year'].setValue(null);
    }
    else {
      const startDate = new Date(event.target.value);
      if (!isNaN(startDate.getTime())) {
        const endDate = new Date(startDate);
        endDate.setFullYear(endDate.getFullYear() + 1);
        endDate.setDate(endDate.getDate() - 1);
        const today = new Date();
        this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].setValue(endDate);
        if (this.datashare.CharityFinancialSubForm.controls['current_AP_Start_Date']) {
          this.datashare.CharityFinancialSubForm.controls['current_AP_Start_Date'].setValue(startDate);
        }
      } else {
      }

      const financialYear = this.getFinancialYear(startDate, 3);
      var FinancialYear = `FY ${financialYear.startYear}-${financialYear.endYear.toString().slice(-2)}`;
      this.datashare.CharityFinancialSubForm.controls['financial_Year'].setValue(FinancialYear);
    }

  }

  //CreateFinancialSubForm() {
  //  debugger
  //  this.CharityFinancialSubForm = new FormGroup({

  //    financialPeriodsID: new FormControl(null),
  //    last_AP_Start_Date: new FormControl(null),
  //    isFirst_AP: new FormControl('yes'),
  //    last_AP_End_Date: new FormControl(null),
  //    current_AP_Start_Date: new FormControl(null, Validators.required),
  //    current_AP_End_Date: new FormControl(null, Validators.required),
  //    financial_Year: new FormControl({ value: null, disabled: true }),
  //    accounting_Method: new FormControl(null, Validators.required),
  //    accounting_Template: new FormControl(null),
  //    fund_Tracking: new FormControl(true),

  //  })
  //  //this.CharityFinancialSubForm.controls['last_AP_Start_Date'].disable()
  //  // this.CharityFinancialSubForm.controls['last_AP_End_Date'].disable()
  //}

  checkIfDayBeforeToday(FromDate: any, Todate?: any): boolean {
    Todate = (!Todate) ? new Date() : Todate
    FromDate = new Date(FromDate)
    if (FromDate > Todate) {

      Swal.fire({
        html: ' <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">The period To date cannot be later than today.</p>',

        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
      })
      return true;
    }
    else { return false }
  }
  Save_AccountingPeriod() {
    debugger

    if ((this.datashare.CharityFinancialSubForm.valid && this.AccountPeriodValidation()) && (!this.checkIfDayBeforeToday(this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].value))) {
      if (this.datashare.CharityFinancialSubForm.controls['accounting_Method'].getRawValue() != 'Accruals (FRS 102 SORP)') {
        this.datashare.CharityFinancialSubForm.controls['accounting_Template'].setValue(null)

      }

      this.datashare.CharityFinancialSubForm.controls['last_AP_Start_Date'].setValue(this.DbDateConverter(this.datashare.CharityFinancialSubForm.controls['last_AP_Start_Date'].value))
      this.datashare.CharityFinancialSubForm.controls['last_AP_End_Date'].setValue(this.DbDateConverter(this.datashare.CharityFinancialSubForm.controls['last_AP_End_Date'].value))
      this.datashare.CharityFinancialSubForm.controls['current_AP_Start_Date'].setValue(this.DbDateConverter(this.datashare.CharityFinancialSubForm.controls['current_AP_Start_Date'].value))
      this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].setValue(this.DbDateConverter(this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].value))
      this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].setValue(this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].value)
      this.datashare.CharityFinancialSubForm.controls['report_Type'].setValue(this.datashare.CharityFinancialSubForm.controls['report_Type'].value)
      localStorage.setItem('ReportType_Method', this.datashare.CharityFinancialSubForm.controls['report_Type'].value);
      var modal = new AccountDetailsModal(this.datashare.CharityFinancialSubForm.getRawValue());
      modal.charityID = localStorage.getItem("currentCharityID")
      modal.UserId = localStorage.getItem("CurrentuserID")
      this.Charities_Service.SaveAccountingPeriod(modal).subscribe((data: any) => {
        this.dialog.closeAll();
        this.datashare.CreateFinancialSubForm()
        this.Getbasicinformation()
        if (data.mesage == "Accounting Period created successfully") {


          Swal.fire({
            html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">  ${data.mesage}.</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">Do you want to open this Accounting Period?</p>`,

            iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
            confirmButtonText: "Yes",
            showCancelButton: true,
            cancelButtonText: "No",
            allowOutsideClick: false,
            reverseButtons: true
          }).then((result) => {
            if (result.value) {
              return
            }
            else {
              return

            }
          });
        }
        else {
          this.msgService.showToastMessage('success', data.mesage)
        }


      })
      return true;

    }
    else {
      this.datashare.CharityFinancialSubForm.markAllAsTouched();
      return false
    }
  }


  AccountPeriodValidation() {
    debugger
    var currentstartdate = new Date(this.datashare.CharityFinancialSubForm.controls['current_AP_Start_Date'].getRawValue())
    var currentendtdate = new Date(this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].getRawValue())
    var lastenddate = new Date(this.datashare.CharityFinancialSubForm.controls['last_AP_End_Date'].getRawValue())
    var laststartdate = new Date(this.datashare.CharityFinancialSubForm.controls['last_AP_Start_Date'].getRawValue())
    if (lastenddate >= currentstartdate) {
      Swal.fire({
        html: ' <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">The Current Period Start Date must be after Last Accounting Period End Date.</p>',

        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
      })
      return false;
    }
    //if ((currentstartdate >= currentendtdate && this.CharityTypeSubForm.controls['charity_Type'].getRawValue() != 'Charitable Company (Incorporated)') || (currentstartdate > currentendtdate && this.CharityTypeSubForm.controls['charity_Type'].getRawValue() == 'Charitable Company (Incorporated)')) {
    if (currentstartdate > currentendtdate) {
      Swal.fire(


        {
          html: ' <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">The Current Period End Date must be on or after the Current Period Start Date.</p>',

          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        }

      )
      return false;
    }
    const monthDifference = this.calculateMonthDifference(currentstartdate, currentendtdate);
    if ((this.datashare.Basicinfodata[0].charity_Type == "Charitable Incorporated Organisation (CIO)" || this.datashare.Basicinfodata[0].charity_Type == "Unincorporated Charity") && (monthDifference < 6 || monthDifference > 18)) {
      var CharityType = this.datashare.Basicinfodata[0].charity_Type
      Swal.fire(
        {
          html: ' <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">The Accounting Period for ' + CharityType + 'should be between 6 to 18 months.</p>',

          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        }
      )
      return false;
    }
    if ((laststartdate > lastenddate) && this.isFirst_AP == 'no') {
      Swal.fire(


        {
          html: ' <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">The Last Period End Date must be on or after the Last Period Start Date.</p>',

          iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        }

      )
      return false;
    }
    if (currentendtdate < this.dateofRegistration) {
      this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].markAsTouched()
      this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].setErrors({ dateofreg: true })
      return false;
    }

    if (this.dateofRemoval != '' && currentendtdate > this.dateofRemoval) {
      this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].markAsTouched()
      this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].setErrors({ dateofrem: true })
      return false;
    }


    return true;
  }

  calculateMonthDifference(startDate: Date, endDate: Date): number {
    const startYear = startDate.getFullYear();
    const startMonth = startDate.getMonth(); // 0-indexed
    const endYear = endDate.getFullYear();
    const endMonth = endDate.getMonth(); // 0-indexed
    // Calculate the difference in months
    return (endYear - startYear) * 12 + (endMonth - startMonth);
  }

  onChange() {
    debugger

    this.datashare.CharityFinancialSubForm.controls['audited_Type'].setValue("CharitiesAct2011")
    const reportType = this.datashare.CharityFinancialSubForm.controls['report_Type'].getRawValue();
    const accountType = this.datashare.CharityFinancialSubForm.controls['account_Type'].getRawValue();
    var fid = localStorage.getItem("currentPeriod")
    if (reportType == 'Independent Examiner' && fid && fid != '') {
      this.Charities_Service.istarreportselected(fid).subscribe((data: any) => {
        if (data != null && data.mesage != null) {
          if (data.mesage == 'Yes' && accountType == 'Original') {
            this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Unaudited Trustees' Report and Financial Statements");
          }
          else if (data.mesage == 'Yes' && accountType == 'Amended') {
            this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Revised Unaudited Trustees' Report and Financial Statements");
          }
          else if (reportType == 'None' && accountType == 'Original') {
            this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Report and Financial Statements");
          }
          else if (reportType == 'None' && accountType == 'Amended') {
            this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Report and Financial Statements");
          }
        }
        else {
          if (reportType == 'Independent Examiner' && accountType == 'Original') {
            this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Unaudited Report and Financial Statements");
          }
          else if (reportType == 'Independent Examiner' && accountType == 'Amended') {
            this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Revised Unaudited Report and Financial Statements");
          }
        }
      })
    }
    else {
      if (reportType == 'Independent Examiner' && accountType == 'Original') {
        this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Unaudited Report and Financial Statements");
      }
      else if (reportType == 'Independent Examiner' && accountType == 'Amended') {
        this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Revised Unaudited Report and Financial Statements");
      }
      else if (reportType == 'Auditor' && accountType == 'Original') {
        this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Trustees' Report and Financial Statements");
      }
      else if (reportType == 'Auditor' && accountType == 'Amended') {
        this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Revised Trustees' Report and Financial Statements");
      }
      else if (reportType == 'None' && accountType == 'Original') {
        this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Report and Financial Statements");
      }
      else if (reportType == 'None' && accountType == 'Amended') {
        this.datashare.CharityFinancialSubForm.controls['report_Title'].setValue("Report and Financial Statements");
      }

    }
  }

  onAuditorChange(value: any) {
    if (value == 'CompaniesAct2006') {
      this.auditExemptionStatement = true;
      this.auditCheck = false;
      this.datashare.CharityFinancialSubForm.get('isAudit_Exemption')?.setValue(false);
    }
    else {
      this.auditExemptionStatement = false;
      this.auditCheck = false;
      this.datashare.CharityFinancialSubForm.get('isAudit_Exemption')?.setValue(false);
    }
  }



  EditAccountPeriod(financialPeriodsID: any, template: any) {
    debugger
    this.datashare.CreateFinancialSubForm()
    this.dialog.open(template, { width: 'auto', maxWidth: "100%", disableClose: true, }); debugger
    this.Charities_Service.EditAccountPeriod(localStorage.getItem('currentPeriod')).subscribe((data: any) => {
      this.datashare.CharityFinancialSubForm.patchValue(data);
      this.substatus = data?.companyHouseSubmissionStatus
      this.datashare.CharityFinancialSubForm.controls['last_AP_Start_Date'].disable()
      //this.datashare.CharityFinancialSubForm.controls['account_Type'].disable()
      var accmethod = this.datashare.CharityFinancialSubForm.controls['accounting_Method'].getRawValue()
      if (accmethod == 'Cash (Receipts & Payments)') {


        this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].disable()
      }
      else {
        this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].enable()
      }
      this.datashare.CharityFinancialSubForm.controls['last_AP_End_Date'].disable();
      this.datashare.CharityFinancialSubForm.controls['current_AP_Start_Date'].disable();
      this.datashare.CharityFinancialSubForm.controls['period_Duration'].disable();
      localStorage.setItem('fund_Tracking', data.fund_Tracking.toString());
      var isEdit = 'true'
      this.calPeriodDuration(data.current_AP_Start_Date, data.current_AP_End_Date, isEdit);
    })
  }

  Close_AccountingPeriod() {
    debugger
    if (this.datashare.CharityFinancialSubForm.dirty) {
      return Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Leave the page?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">Are you sure you want to leave the page.<br\>Data entered will not be saved.</p>',

        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Leave",
        showCancelButton: true,
        cancelButtonText: "Stay",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.datashare.CreateFinancialSubForm()
          this.dialog.closeAll()
          return true;
        }
        else {
          return
        }
      })
    }
    else {
      this.dialog.closeAll()
      this.datashare.CreateFinancialSubForm()
      return true;
    }


  }
  backToCharityOverView() {
    debugger
    this.ShowSpinner = true;
    localStorage.setItem('isFromBasicInfo', 'true')

    this.router.navigate(['/charity']);
  }
  GetFinalAccountStatus(PeriodId: any, Record?: any) {
    debugger;
    this.apiservice.GetFinalStatus(PeriodId).subscribe((data: any) => {
      debugger
      this.dataShareService.setFinalStatus(data.mesage)
    })
  }
  Getbasicinformation() {
    debugger
    var Id = localStorage.getItem("SwitchcurrentPeriod")
    if (localStorage.getItem("currentPeriod") != localStorage.getItem("SwitchcurrentPeriod") && Id != null && Id != '') {
      localStorage.setItem("currentPeriod", Id != null && Id != '' ? Id : '')
      localStorage.setItem("SwitchcurrentPeriod", '')
    }
    const period = localStorage.getItem('currentPeriod');
    const charityId = localStorage.getItem('currentCharityID');
    /*alert('hitted')*/

    this.Charities_Service.Getbasicinfo(charityId, period).subscribe((data: any) => {
      debugger
      this.dataShareService.updateAccountMethodType(data[0].accounting_Method.toString());
      this.dataShareService.updateAccountReportType(data[0].report_Type.toString());
      var start = moment(data[0].current_AP_Start_Date, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");
      var end = moment(data[0].current_AP_End_Date, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");
      this.datashare.diffDays = (moment(end, "DD/MM/YYYY").diff(moment(start, "DD/MM/YYYY"), "days")) + 1;
      this.datashare.Basicinfodata = data;
      localStorage.setItem('FY_Year', this.datashare.Basicinfodata[0].financial_Year);

      localStorage.setItem('Current_AP_End_Date', data[0]?.current_AP_End_Date ?? '')

      this.datashare.createdDate = moment(data[0].createdDate, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");
      this.datashare.modifiedDate = data[0].modifiedDate ? moment(data[0].modifiedDate, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY") : '-';
      this.datashare.CharityFinancialSubForm.controls['fund_Tracking'].setValue(data[0].fund_Tracking);
      localStorage.setItem('fund_Tracking', data[0].fund_Tracking);
      localStorage.setItem('IsFirstAccountingPeriod', data[0].withPrevoiusPeriod == 1 ? 'true' : 'false');
      localStorage.setItem('Charity_Type', data[0].charity_Type);
      localStorage.setItem('account_Type', data[0].account_Type.toString());
      this.calPeriodDuration(data[0].current_AP_Start_Date, data[0].current_AP_End_Date)
      //calculating Submission Deadline
      const originalDate = new Date(data[0].current_AP_End_Date);
      const newDate = new Date(originalDate);
      newDate.setMonth(newDate.getMonth() + 9);
      this.submissionDeadline = moment(newDate, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY");

    })
    this.GetFinalAccountStatus(period)
  }
  deleteAccountPeriod() {
    debugger
    Swal.fire({
      html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px">Do you want to delete this Accounting Period?</p>`,

      iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
      confirmButtonText: "Yes",
      showCancelButton: true,
      cancelButtonText: "No",
      allowOutsideClick: false,
      reverseButtons: true
    }).then((result) => {
      if (result.value) {
        this.Charities_Service.deleteAccountPeriod(localStorage.getItem('currentPeriod')).subscribe((data: any) => {
          debugger
          this.msgService.showToastMessage('success', data.mesage)
          this.backToCharityOverView();
        })
      }
      else {
        return

      }
    })
  }
  MovetoTrialTalance() {
    debugger
    // this.spinner.show()
    this.router.navigate(['/trialbalance']);
  }
  GetAccountingPeriods() {
    this.AccountPeriodGrid = []
    const charityId = localStorage.getItem('currentCharityID');
    this.Charities_Service.GetAccountsGrid(charityId).subscribe((Response: any) => {
      debugger
      this.AccountPeriodGrid = Response;
    })

  }
  Getcharitydetails() {
    var charityID = localStorage.getItem('currentCharityID')
    this.Charities_Service.EditCharityDetails(charityID).subscribe((data: CharityDetailsModal[]) => {
      debugger
      this.dateofRemoval = new Date(moment(data[0].date_of_Removal, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY"))
      this.dateofRegistration = new Date(moment(data[0].date_of_Registration, 'YYYY-MM-DD HH:mm:ss').format("DD/MM/YYYY"))
    })
  }
  calPeriodDuration(startAPDate?: any, endAPDate?: any, isEdit?: any) {
    debugger
    if (startAPDate == undefined || endAPDate == undefined) {
      var startDate = moment(this.datashare.CharityFinancialSubForm.controls['current_AP_Start_Date'].value, 'YYYY-MM-DD HH:mm:ss');
      var endDate = moment(this.datashare.CharityFinancialSubForm.controls['current_AP_End_Date'].value, 'YYYY-MM-DD HH:mm:ss');
    }
    else {
      var startDate = moment(startAPDate, 'YYYY-MM-DD HH:mm:ss');
      var endDate = moment(endAPDate, 'YYYY-MM-DD HH:mm:ss');
    }
    var start = moment(startDate, "DD/MM/YYYY");
    var end = moment(endDate, "DD/MM/YYYY");

    const totalDays = end.diff(start, 'days') + 1;
    if (totalDays === 365 || totalDays === 366) {
      this.totalMonthsCount = 12;
      this.totalDaysCount = 0;
    } else {
      this.totalMonthsCount = end.diff(start, 'months');
      const intermediate = start.clone().add(this.totalMonthsCount, 'months');
      this.totalDaysCount = end.diff(intermediate, 'days') + 1;
    }
    //this.totalMonthsCount = end.diff(start, 'months');
    //var intermediate = start.clone().add(this.totalMonthsCount, 'months');
    //this.totalDaysCount = end.diff(intermediate, 'days')+1;
    // this.CharityFinancialSubForm.controls['period_Duration'].setValue(this.totalMonthsCount > 0 ? this.totalMonthsCount + " Months(s)" : this.totalDaysCount + " Day(s)");
    if (isEdit != 'true') {
      this.datashare.Basicinfodata[0].period_Duration = this.totalMonthsCount > 0 ? this.totalMonthsCount + ' Month(s)' : this.totalDaysCount > 0 ? + this.totalDaysCount + ' Day(s)' : '0 Day(s)';
    }
    else {
      this.datashare.CharityFinancialSubForm.controls['period_Duration'].setValue(this.totalMonthsCount > 0 ? this.totalMonthsCount + ' Month(s)' : this.totalDaysCount > 0 ? + this.totalDaysCount + ' Day(s)' : '0 Day(s)');
    }
  }
  UnlockandAmend() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Amend) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Unlocking the accounting period will allow you to amend the filed accounts and correct any errors. After making any changes, the accounts must be submitted again as an Amended filing. Do you want to unlock and amend the accounting period?</p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.ShowSpinner = true
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            this.ShowSpinner = false
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
            localStorage.setItem('NewAmendCycle', 'true');
            this.datashare.Basicinfodata[0].account_Type = 'Amended'
            if (this.datashare.Basicinfodata[0].account_Type == 'Amended' && this.datashare.Basicinfodata[0].report_Type == 'Independent Examiner') {
              this.datashare.Basicinfodata[0].report_Title = "Revised Unaudited Trustees' Report and Financial Statements"
            }
            else if (this.datashare.Basicinfodata[0].account_Type == 'Amended' && this.datashare.Basicinfodata[0].report_Type == 'Auditor') {
              this.datashare.Basicinfodata[0].report_Title = "Revised Trustees' Report and Financial Statements"
            }
            else if (this.datashare.Basicinfodata[0].account_Type == 'Amended' && this.datashare.Basicinfodata[0].report_Type == 'None') {
              this.datashare.Basicinfodata[0].report_Title = "Report and Financial Statements"
            }
          })
          //this.save("FinaliseandClose");
        }
        else { }
      })
    }
    else {
      Swal.fire({
        html: '<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel"></h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  UnfreezeAP() {
    debugger
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      Swal.fire({
        html: `<h5 class="f-s-16 f-w-600 text-black" id="exampleModalLiveLabel">Are you sure?</h5> <p class= "f-s-14 p-0 m-y-5 f-w-400 text-black" style="line-height:22px; padding-right: 30px !important;"> Do you want to unlock the Accounting Period? </p>`,
        iconHtml: '<span class="fa fa-exclamation rounded-icon"></span>',
        confirmButtonText: "Yes",
        showCancelButton: true,
        cancelButtonText: "No",
        allowOutsideClick: false,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.ShowSpinner = true
          this._UsermanagementService.UnfreezeAP(+fid).subscribe((data: any) => {
            debugger
            this.ShowSpinner = false
            const message = "Accounting Period unlocked successfully";
            this.msgService.showToastMessage('success', message)
            this.sharedService.setFinalStatus('InCompleted');
            localStorage.setItem('apFinalised', 'InCompleted')
          })
        }
      })
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }
  }
  gotoSubmissions() {
    var fid: any = localStorage.getItem('currentPeriod') ? localStorage.getItem('currentPeriod') : 0
    if (this.UserRoleAccess.m1Submit) {
      this._UsermanagementService.GoToSubmissions()
    } else {
      Swal.fire({
        html: '<p class= "f-s-14 p-0 m-y-5 f-w-400 text-black"  style="line-height:22px"> <b>Access Denied</b> <br/> You do not have the required permissions to perform this action</p>',
        iconHtml: '<span class="fa fa-warning"></span>',
        confirmButtonText: "OK",
        allowOutsideClick: false
      })
    }

  }

}
